module.exports = __webpack_public_path__ + "static/img/shape_13.7180a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_13.png
// module id = nmcA
// module chunks = 0